import axios, { AxiosPromise } from 'axios';
import { IAccreditation } from '../../../@types/model/masterData/accreditation/accreditation';
import { IAccreditationUpsert } from '../../../@types/model/masterData/accreditation/accreditationUpsert';

export default class AccreditationHttpService {
    public static getAccreditationData() : AxiosPromise<Array<IAccreditation>> {
        return axios.get(`${API_URL}/v1/Accreditation/GetAllWeb`);
    }

    public static addOrUpdateAccreditation(data : IAccreditationUpsert) : AxiosPromise<IAccreditation> {
        return axios.post(`${API_URL}/v1/Accreditation/PostAccreditation`, data);
    }

    public static deleteAccreditation(accreditationId : number) : AxiosPromise<IAccreditation> {
        return axios.delete(`${API_URL}/v1/Accreditation/Delete`, {
            params : { accreditationId },
        });
    }
}
